import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import { Riesgo } from "./contexto/ClasesGrales";
import { colores, HOY, toInput, toOutput, SInput, SEtiqueta, SInputD, Scrudo } from "./general";
import Boton from "./Boton.js";

export default function CRUDriesgo({ riesgo, set }) {
  // set permite actualizar variable para visualizar pantalla
  let { firebase } = useContext(AppContext);
  let color = colores["riesgos"];

  const [r, setR] = useState(riesgo ? riesgo : new Riesgo(firebase.proyectoActivo.proyecto.id, "...nuevo..."));
  const [change, setChange] = useState(false)

  useEffect(() => {
    document.getElementById("Rfechai").value = toInput(r.inicio);
  }, [r.inicio]);

  async function actualizarRiesgo() {
    await firebase.actualizarRiesgo(r);
    if (set) set(false);
    setChange(false)
  }

  return (
    <div style={Scrudo}>
      <div style={Sdescripcion}>
        <div style={{ ...SEtiqueta, marginBottom: "5px" }}>{r.id} - Descripción:</div>
        <textarea
          rows="4"
          style={SInputD}
          value={r.descripcion}
          onChange={(e) => {
            e.persist(); setChange(true);
            setR((r) => ({ ...r, descripcion: e.target.value }));
          }}
        ></textarea>
      </div>

      <div style={SDataEntry}>
        <div style={SEtiqueta}>Probabilidad/Impacto:</div>
        <select
          value={r.prioridad}
          onChange={(e) => {
            e.persist(); setChange(true);
            setR((r) => ({ ...r, prioridad: e.target.value }));
          }}
          style={{ ...SInput, background: `${color[r.prioridad]}` }}
        >
          <option value=""></option>
          <option value="Alto" style={{ background: `${color["Alto"]}` }}>
            Alto
          </option>
          <option value="Medio" style={{ background: `${color["Medio"]}` }}>
            Medio
          </option>
          <option value="Bajo" style={{ background: `${color["Bajo"]}` }}>
            Bajo
          </option>
        </select>

        <div style={SEtiqueta}>Estado:</div>
        <select
          style={SInput}
          value={r.estado}
          onChange={(e) => {
            e.persist(); setChange(true);
            setR((r) => ({ ...r, estado: e.target.value, fechaCierre: e.target.value === "cerrado" ? HOY : 0 }));
          }}
        >
          <option value="abierto">Abierto</option>
          <option value="cerrado">Cerrado</option>
        </select>

        <div style={SEtiqueta}>Fecha Inicio:</div>
        <input
          id="Rfechai"
          type="date"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setR((r) => ({ ...r, inicio: toOutput(e.target.value) }));
          }}
        ></input>

        <div style={SEtiqueta}>Responsable:</div>
        <select
          value={r.responsable}
          onChange={(e) => {
            e.persist(); setChange(true);
            setR((r) => ({ ...r, responsable: e.target.value }));
          }}
          style={SInput}
        >
          {firebase.dataUsuarios.map((u, i) => (
            <option key={i} value={u.id}>
              {u.nombre}
            </option>
          ))}
        </select>
      </div>
      <Boton accion={actualizarRiesgo} change={change} />
    </div>
  );
}

const Sdescripcion = {
  marginBottom: "5px"
};

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "55% 40%",
  rowGap: "5px",
  columnGap: "5px"
};


